var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExterior(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9937717,0.267903479 L17.1330576,0.35667623 L31.1330576,10.1118656 C31.6305405,10.4585113 31.9444438,11.012333 31.9933063,11.6163756 L32,11.7822417 L32,32 L0,32 L0,11.7822417 C0,11.1703652 0.272446454,10.5944409 0.735877975,10.211424 L0.866942354,10.1118656 L14.8669424,0.35667623 C15.5039461,-0.0871875228 16.3313775,-0.11677844 16.9937717,0.267903479 Z M16,2.02705234 L2,11.7822417 L2,29.9739612 L5,29.973 L5,12.7430027 C5,11.6234927 5.8954305,10.7159504 7,10.7159504 L25,10.7159504 C26.1045695,10.7159504 27,11.6234927 27,12.7430027 L27,29.973 L30,29.9739612 L30,11.7822417 L16,2.02705234 Z M25,25.918 L7,25.918843 L7,29.9729477 L25,29.9729477 L25,25.918 Z M25,19.837 L7,19.8376859 L7,23.8917906 L25,23.891 L25,19.837 Z M12,12.743 L7,12.7430027 L7,17.8106336 L12,17.81 L12,12.743 Z M18,12.743 L14,12.743 L14,17.81 L18,17.81 L18,12.743 Z M25,12.7430027 L20,12.743 L20,17.81 L25,17.81 L25,12.7430027 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExterior);
export default __webpack_public_path__ + "static/media/exterior.38b3d259c9773f1875b0ab5403f6bee5.svg";
export { ForwardRef as ReactComponent };